import React, { useState } from "react";
import { Tooltip } from "antd";
import { AudioOutlined } from "@ant-design/icons";
import VoiceShiftModal from "./VoiceShiftModal";
import "./VoiceShiftButton.scss";

interface Props {
  clientId: string;
  onShiftCreated: () => void;
}

export default function VoiceShiftButton({ clientId, onShiftCreated }: Props) {
  const [open, setOpen] = useState(false);

  const isSupported =
    typeof window !== "undefined" &&
    !!(
      (window as any).SpeechRecognition ||
      (window as any).webkitSpeechRecognition
    );

  if (!isSupported) return null;

  return (
    <>
      <Tooltip title="Create or delete shift with voice" placement="bottom">
        <button
          className="vsb-trigger"
          onClick={() => setOpen(true)}
          aria-label="Voice shift"
        >
          <span className="vsb-icon-wrap">
            <AudioOutlined />
          </span>
          <span className="vsb-label">Voice</span>
        </button>
      </Tooltip>

      {open && (
        <VoiceShiftModal
          clientId={clientId}
          onShiftCreated={onShiftCreated}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
